import { useIntl } from 'react-intl';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';
import { Neutral } from '@sorare/core/src/atoms/icons/Neutral';
import { Promotion } from '@sorare/core/src/atoms/icons/Promotion';
import { Relegation } from '@sorare/core/src/atoms/icons/Relegation';
import type { unitMapping } from '@sorare/core/src/lib/style';

import { messages } from '../messages';

const icons = {
  [DivisionChange.PROMOTED]: Promotion,
  [DivisionChange.RELEGATED]: Relegation,
  [DivisionChange.STABLE]: Neutral,
};

type Props = {
  divisionChange: DivisionChange;
  size?: keyof typeof unitMapping;
  title?: string;
};

export const DumbStatus = ({ divisionChange, size, title }: Props) => {
  const { formatMessage } = useIntl();

  const Component = icons[divisionChange];

  return (
    <Component
      size={size}
      title={title || formatMessage(messages[divisionChange])}
    />
  );
};
